/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.services
 * @name     csm.books.services.NewBooksData.type:Address
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Address information. Mirrors `csm.booksdb.data.Address`.
 *******************************************************************************/
AddressConfig.$inject = ['TypeFactoryProvider'];
/* @ngInject */ export function AddressConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'NewBooksData.Address',
    $type: 'csm.booksdb.data.Address, CSMBooksDBCS',
    prototype: {
      id: 0, // Address ID.
      address: null, // Street address.
      city: null, // City name.
      state: null, // State acronym.
      zip: null, // Zip code, 5 or 9 digits.
      country: null, // Country name.
      phone1: null, // Primary phone number.
      phone2: null, // Secondary phone number.
      fax: null, // Fax number.
      email: null, // EMail address.
      website: null // Website URL.
    }
  });
}
